import { animated } from '@react-spring/web';
import * as React from 'react';
import styled from 'styled-components';

interface ISlide {
  slideRef: any;
  galleryOpen: boolean;
  galleryOverviewOpen: boolean;
  attr: any;
  text?: string;
  current: number;
  numberOfSlides: number;
  show: boolean;
  clickable: boolean;
  onClick: () => void;
}

export const Slide: React.FC<ISlide> = React.memo(
  ({
    slideRef,
    galleryOpen,
    galleryOverviewOpen,
    attr,
    text,
    current,
    numberOfSlides,
    show,
    clickable,
    onClick,
  }) => {
    const [loaded, setLoaded] = React.useState<boolean>(false);

    const handleImageLoad = React.useCallback(() => {
      setLoaded(true);
    }, [loaded]);

    let className = '';
    if (loaded) {
      className = 'loaded';
    }
    if (clickable) {
      className = ' clickable';
    }

    return (
      <>
        {galleryOpen && !galleryOverviewOpen && show ? (
          <StyledSlideshowSlideTextWrapper>
            <StyledSlideshowSlideText>
              {text ? <span className="text">{text}</span> : null}
              <span>
                ({current + 1} av {numberOfSlides})
              </span>
            </StyledSlideshowSlideText>
          </StyledSlideshowSlideTextWrapper>
        ) : null}
        <StyledSlide
          ref={slideRef}
          className={galleryOpen ? 'slide gallery-open' : 'slide'}
          show={show.toString()}
        >
          <SlideImg
            {...attr}
            onLoad={handleImageLoad}
            draggable={false}
            galleryOpen={galleryOpen}
            className={className}
            onClick={(e) => {
              if (typeof onClick === 'function') {
                e.preventDefault();
                e.stopPropagation();
                onClick();
              }
            }}
          />
        </StyledSlide>
      </>
    );
  }
);

const StyledSlide = styled(animated.div)<{
  show: string;
}>`
  display: ${({ show }) => (show === 'true' ? 'flex' : 'none')};
  justify-content: center;
  align-items: center;
  position: absolute;
  padding: 0;
  width: 100%;
  height: 100vh;
  height: calc(var(--vh, 1vh) * 100);
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;

  &.gallery-open {
    padding: 40px 0;
  }
`;

const SlideImg = styled.img<{ galleryOpen: boolean }>`
  transition: opacity 0.15s ease-in-out, object-fit 0.15s ease-in-out;
  width: 100%;
  height: 100%;
  object-fit: ${(props) => (props.galleryOpen ? 'contain' : 'cover')};
  border: 0;
  opacity: 0;
  flex-shrink: 0;

  &.loaded {
    opacity: 1;
  }

  &.clickable {
    &:hover {
      cursor: pointer;
    }
  }
`;

const StyledSlideshowSlideTextWrapper = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: calc(var(--vh, 1vh) * 100);
  z-index: 9998;
  pointer-events: none;
`;

const StyledSlideshowSlideText = styled.div`
  padding: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  width: 100%;
  font-size: 14px;
  background: rgba(0, 0, 0, 0.6);
  color: white;
  text-align: center;
  z-index: 9999;
  pointer-events: auto;
  bottom: 0;
  .text {
    font-weight: 300;
  }

  span {
    margin-left: 10px;
    font-weight: 600;
  }

  @media all and (max-width: 1200px) {
    flex-flow: column;

    .text {
      margin-bottom: 10px;
      font-weight: 300;
    }

    span {
      font-weight: 600;
    }
  }
`;
